import styles from './styles.module.css';
import { useState, useEffect, createContext, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import SocketContext from "../socket-context";

const RoomAndUsers = ({ username, setUsername, room, setRoom, socket }) => {

  const socketData = useContext(SocketContext);
  const navigate = useNavigate();

  const leaveRoom = () => {
    const __createdtime__ = Date.now();
    socket.emit('leave_room', { username, room, __createdtime__ });

    setUsername('');
    setRoom('');
    socketData.setMessagesReceived([])
    
    // localStorage.removeItem("roomJoined")
    // localStorage.removeItem("usernameJoined")

    // Redirect to home page
    navigate('../join-room', { replace: true });
  };

  return (
    <div className={styles.roomAndUsersColumn}>
      {/* <h2 className={styles.roomTitle}>{room}</h2> */}

      <div>
        {socketData.roomUsers.length > 0 && <h5 className={styles.usersTitle}>Users:</h5>}
        <ul className={styles.usersList}>
          {socketData.roomUsers.map((user) => (
            <li
              style={{
                fontWeight: `${user.username === username ? 'bold' : 'normal'}`,
              }}
              key={user.id}
            >
              {user.username}
            </li>
          ))}
        </ul>
      </div>

      <button className='btn btn-outline' onClick={leaveRoom}>
        Leave
      </button>
    </div>
  );
};

export default RoomAndUsers;